import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../components/Navbar";

const SECTIONS = [
  {
    id: "privacy",
    title: "Privacy Policy",
    body: [
      "Ajemi Oil & Gas Ltd. (\"Ajemi\", trading commercially as Ajemi Energy) respects the privacy of every customer, supplier and website visitor.",
      "Information you provide through this website and platform — including company details, contact information, procurement requirements and uploaded documents — is used solely to evaluate, coordinate and manage your procurement requests and supplier relationships.",
      "Procurement documents are stored securely and are accessible only to your account and authorized Ajemi personnel. Customers cannot access supplier databases, and suppliers cannot access customer databases.",
      "We do not sell your information to third parties. Information is shared with supply partners only to the extent required to fulfil a specific procurement transaction, and only with your approval of the relevant proposal.",
      "For any privacy enquiry, contact us at procurement@ajemienergy.com or +234 915 198 1008.",
    ],
  },
  {
    id: "terms",
    title: "Terms of Service",
    body: [
      "These terms govern the use of the Ajemi Energy website and procurement platform, operated by Ajemi Oil & Gas Ltd.",
      "Ajemi acts as a procurement and coordination partner. Ajemi identifies supply options, coordinates commercial arrangements and supports procurement workflows between customers and qualified supply partners.",
      "Submitting a procurement request does not create a binding supply obligation. Each transaction is governed by the specific commercial agreement between the relevant parties, including product, volume, price, delivery and payment terms.",
      "Ajemi does not hold customer funds, operate wallets or act as an escrow agent. Payment and settlement follow the agreed commercial arrangement between the transaction parties.",
      "Quotations and proposals are subject to availability, validity periods and final commercial confirmation.",
    ],
  },
  {
    id: "supplier-terms",
    title: "Supplier Terms",
    body: [
      "Supply partners are admitted to the Ajemi network following a review of company information, product capability, locations served and supporting documentation.",
      "Suppliers receive procurement opportunities at Ajemi's discretion, matched to the supplier's stated capability and the specific transaction requirements. Admission to the network does not guarantee any volume of orders.",
      "Offers submitted through the supplier portal must be accurate, commercially valid for the stated period and honour the confirmed product specifications.",
      "Awarded opportunities must be fulfilled according to the agreed commercial and delivery terms. Ajemi may suspend or remove suppliers that fail to meet agreed standards.",
      "Supplier information is never publicly displayed and is used only for procurement coordination.",
    ],
  },
  {
    id: "customer-terms",
    title: "Customer Terms",
    body: [
      "Customers submit procurement requirements through the Ajemi platform — one-time, recurring, multi-location or international — and receive a structured Ajemi procurement proposal for approval.",
      "A procurement transaction proceeds only after the customer approves the recommended proposal. Customers may approve, request clarification or decline any proposal.",
      "Recurring supply programs are coordinated per the agreed schedule and commercial arrangement; pricing, availability and credit terms are agreed per transaction and are not guaranteed unless specifically agreed in writing.",
      "Customers are responsible for the accuracy of their procurement requirements, delivery locations and documentation.",
      "For support, contact the Ajemi Procurement Desk at procurement@ajemienergy.com.",
    ],
  },
];

export default function Legal() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-ink text-white" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="flex items-center justify-between mb-14">
          <Link to="/" data-testid="legal-logo">
            <Logo />
          </Link>
          <Link to="/" className="text-sm text-white/50 hover:text-gold transition-colors" data-testid="legal-back-link">
            ← Back to site
          </Link>
        </div>
        <h1 className="font-outfit text-4xl font-extralight tracking-tight mb-2">
          Legal <span className="text-gold">Information</span>
        </h1>
        <p className="text-sm text-white/50 mb-14">
          Ajemi Energy is the commercial brand of Ajemi Oil &amp; Gas Ltd.
        </p>
        <div className="space-y-16">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} data-testid={`legal-${s.id}`} className="scroll-mt-24">
              <h2 className="font-outfit text-2xl font-light text-white mb-5 border-b border-gold/30 pb-3">
                {s.title}
              </h2>
              <div className="space-y-4">
                {s.body.map((p, i) => (
                  <p key={i} className="text-sm text-white/60 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
        <p className="text-xs text-white/30 mt-16 pt-8 border-t border-white/8">
          © {new Date().getFullYear()} Ajemi Oil &amp; Gas Ltd. All rights reserved.
        </p>
      </div>
    </div>
  );
}
